import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Careers from './pages/Careers/Careers';
import Solutions from './pages/Solutions/Solutions';
import BuddyCan from './pages/Solutions/BuddyCan';
import SmartTank from './pages/Solutions/SmartTank';
import DOT from './pages/Solutions/DOT';
import FBVault from './pages/Solutions/FBVault';
import Contact from './pages/Contact/Contact';
import OrderFlow from './pages/Order/OrderFlow';
import RefundPolicy from './components/Footer/Refund';
import TermsConditions from './components/Footer/Terms';
import PrivacyPolicy from './components/Footer/Privacy';
import DeliveryPolicy from './components/Footer/DeliveryPolicy';

export default function App() {
  const [page, setPage] = useState('home');
  const [orderPrices, setOrderPrices] = useState(null);

  const navigate = (p, options = {}) => {
    if (p === 'order' && options.fuelPrices) {
      setOrderPrices(options.fuelPrices);
    }
    setPage(p);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPage = () => {
    switch (page) {
      case 'home': return <Home navigate={navigate} />;
      case 'about': return <About navigate={navigate} />;
      case 'careers': return <Careers navigate={navigate} />;
      case 'solutions': return <Solutions navigate={navigate} />;
      case 'buddy-can': return <BuddyCan navigate={navigate} />;
      case 'smart-tank': return <SmartTank navigate={navigate} />;
      case 'dot': return <DOT navigate={navigate} />;
      case 'fb-vault': return <FBVault navigate={navigate} />;
      case 'contact': return <Contact navigate={navigate} />;
      case 'order': return <OrderFlow navigate={navigate} fuelPrices={orderPrices} />;
      case 'privacy': return <PrivacyPolicy navigate={navigate} />;
      case 'terms': return <TermsConditions navigate={navigate} />;
      case 'refund': return <RefundPolicy navigate={navigate} />;
      case 'delivery': return <DeliveryPolicy navigate={navigate} />;
      default: return <Home navigate={navigate} />;
    }
  };

  return (
    <div className="fd-app">
      <Navbar navigate={navigate} currentPage={page} />
      <main className="fd-main">{renderPage()}</main>
      {page !== 'order' && <Footer navigate={navigate} />}
    </div>
  );
}